import { InvoiceByJobFilters as Filters } from './useInvoiceByJobFilters'
import MultiSelect from '../../common/FormControls/MultiSelect'

type FieldsProps = { filters: Filters }

const VisitReviewStatusFilter = ({ filters, style }: FieldsProps & { style?: React.CSSProperties }) => {
  const visitReviewStatus = filters.state.visitReviewStatus!

  return <MultiSelect
    options={visitReviewStatus.values.map(x => ({ label: x.name, value: x.value }))}
    selectedValues={visitReviewStatus.values.filter(x => x.selected).map(x => x.value)}
    onChange={selectedValues => filters.setCategory('visitReviewStatus', selectedValues)}
    placeholder="Select visit review statuses"
    allSelectedText="All Visit Review Statuses"
    maxTagCount={2}
    style={style}
  />
}

export default VisitReviewStatusFilter
